import TableElement from 'components/organisms/players-to-exchange/table-elements/table-element';
import {ConfirmedComponent} from 'components/atoms/tooltip/confirmed-component';
import React from 'react';
import TeamLogo from 'components/molecules/team-logo';
import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import BuilderInterface from 'components/organisms/players-to-exchange/available-players/builder-interface';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';
import BasePlayerBuilder from 'components/organisms/players-to-exchange/available-players/base-player-builder';

export default class TiersBuilder extends BasePlayerBuilder implements BuilderInterface {
    getTableHead(): Array<TableElement> {
        const elements = {
            'td-pos': 'Pos',
            'td-name': 'Name',
            'td-tier': 'Tier',
            'td-confirm': 'Confirmed',
            'narrow-th': 'Order',
            'td-team': 'Team',
            'td-opponent': 'Opponent',
            'td-hand': 'Hand',
            'td-rating': 'Rating',
            'td-fpts': 'Fpts',
            '': '',
        };

        return this.buildRow(elements);
    }

    getTableBody(
        player: PlayerInterface,
        substitutablePlayer: PlayerInterface,
        lineup: LineupInterface,
        salaryCapExceeded: boolean,
    ): Array<TableElement> {
        const elements = {
            'td-pos': player.positionName,
            'td-name': player.name,
            'td-tier': player.rosterPosition,
            'td-confirm': <ConfirmedComponent player={player} />,
            'narrow-th': player.order ? `#${player.order}` : '',
            'td-team': <TeamLogo teamName={player.team} />,
            'td-opponent': <TeamLogo teamName={player.opponent} />,
            'td-hand': player.getPropValue('hand'),
            'td-rating': player.grades,
            'td-fpts': player.getUserPointsByMode(),
            '': this.getSwapButton(salaryCapExceeded, substitutablePlayer, player, lineup),
        };

        return this.buildRow(elements);
    }
}
